import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { first } from 'rxjs/operators';
import { CouponService } from '../../../services/coupon.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-edit-coupons',
  templateUrl: './add-edit-coupons.component.html',
  styleUrls: ['./add-edit-coupons.component.scss']
})
export class AddEditCouponsComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  coupon: any = {};
  id: number;

  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private couponService: CouponService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      code: ['', Validators.required],
      description: ['', Validators.required],
      discount: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      status: ['', Validators.required],
      limit: ['', Validators.required]
    });

    this.id = this.activatedRoute.snapshot.params['id'];

    if (this.id) {
      this.spinner.show();
      this.couponService.getById(this.id).pipe(first()).subscribe(response => {
        this.spinner.hide();
        this.form.patchValue(response.data);
        this.coupon = response.data;
      }, error => {
        this.spinner.hide();
        this.router.navigate(['']);
      });
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  sendForm(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    this.spinner.show();
    const couponData = this.form.value;
    if (this.id) {
      couponData.id = this.id;
      this.couponService.update(couponData)
        .pipe(first())
        .subscribe(
          response => {
            this.spinner.hide();
            this.toastrService.success(response.message, 'Éxito!');
            this.router.navigate(['/coupons']);
          },
          error => {
            this.spinner.hide();
            this.toastrService.error(error, 'Error');
            this.loading = false;
          });
    } else {
      this.couponService.store(couponData)
        .pipe(first())
        .subscribe(
          response => {
            this.spinner.hide();
            this.toastrService.success(response.message, 'Éxito!');
            this.router.navigate(['/coupons']);
          },
          error => {
            this.spinner.hide();
            this.toastrService.error(error, 'Error');
            this.loading = false;
          });
    }
  }
}